/**
 * Displays a saved signature image in a dialog.
 */
import { Typography, Box } from "@mui/material";

const SignatureViewer = ({ signature, name, title }: any) => {
  return (
    <Box sx={{ mt: 2, textAlign: "center" }}>
      <Typography variant="body1">{title}</Typography>

      {signature && (
        <Box
          sx={{
            width: 200,      
            height: 100,        
            border: "1px solid #000",
            mt: 1,
            mx: "auto",        
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={signature}
            alt="Firma de realización"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain", 
            }}
          />
        </Box>
      )}

      <Typography variant="body1">{name}</Typography>
    </Box>
  );
};

export default SignatureViewer;
